import { ref } from 'vue';
import { trackSpace, allTrack, deleteTrack } from '@blade-sxp/search-center/api/index';
export const useRecordDetail = (snapImageList) => {
    const dialogVisible = ref(false);
    const viewList = ref([]);
    const detailLoading = ref(false);
    const showPath = ref(true);
    const maxNums = ref(0);
    let routeData = [];
    const activeIndex = ref({
        imgIdx: 0,
        groupIdx: 0,
    });
    const viewDetails = (val, imgIdx, groupIdx, list) => {
        viewList.value = list;
        activeIndex.value = { imgIdx, groupIdx };
        openDetails();
    };
    const closeDetails = () => {
        closeDialog();
    };
    const openDetails = () => {
        dialogVisible.value = true;
    };
    const closeDialog = () => {
        dialogVisible.value = false;
    };
    const next = () => {
        handleImageChange(1);
    };
    const prev = () => {
        handleImageChange(-1);
    };
    const handleImageChange = (changeVal) => {
        const { imgIdx, groupIdx } = activeIndex.value;
        if (changeVal > 0 && imgIdx === viewList.value.length - 1) {
            if (groupIdx === snapImageList.value.length - 1)
                return;
            activeIndex.value.groupIdx++;
            viewList.value = snapImageList.value[groupIdx + 1].list;
            activeIndex.value.imgIdx = 0;
        }
        else if (imgIdx === 0 && groupIdx === 0) {
            return false;
        }
        else if (changeVal < 0 && imgIdx === 0) {
            activeIndex.value.groupIdx--;
            viewList.value = snapImageList.value[groupIdx - 1].list;
            activeIndex.value.imgIdx = viewList.value.length - 1;
        }
        else {
            activeIndex.value.imgIdx += changeVal < 0 ? -1 : 1;
        }
    };
    const addRoute = (img) => {
        const params = {
            ...img,
            trackType: 'OBJECT_FACE',
        };
        detailLoading.value = true;
        trackSpace(params)
            .then((res) => {
            img.checked = true;
            showPath.value = false;
            getAllcount();
        })
            .finally(() => {
            detailLoading.value = false;
        });
    };
    const getAllcount = () => {
        allTrack().then((res) => {
            if (res) {
                routeData = res;
                maxNums.value = res.length;
            }
        });
    };
    const deletedRoute = (img) => {
        const route = routeData.find((e) => e.captureUrl === img.captureUrl);
        if (!route)
            return;
        deleteRoute(route.id, route);
    };
    const deleteRoute = (imageId, route) => {
        detailLoading.value = true;
        deleteTrack(imageId)
            .then((res) => {
            getAllcount();
            showPath.value = true;
        })
            .finally(() => {
            detailLoading.value = false;
        });
    };
    const showBtn = (btnPath) => {
        showPath.value = btnPath;
    };
    return { viewDetails, closeDetails, next, prev, addRoute, deletedRoute, showBtn, dialogVisible, viewList, activeIndex, showPath, detailLoading, maxNums };
};
